module.exports = __webpack_public_path__ + "static/media/degas-7.313e1c09.jpeg";